var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useMutation } from "@apollo/client";
import { CREATE_COMMENT_MUTATION, DELETE_COMMENT_MUTATION, LIKE_COMMENT_MUTATION, UNLIKE_COMMENT_MUTATION, UPDATE_COMMENT_MUTATION } from "../comment-mutation-queries";
export var useCommentMutations = function () {
  var _a = __read(useMutation(CREATE_COMMENT_MUTATION), 2),
    createComment = _a[0],
    createError = _a[1].error;
  var _b = __read(useMutation(UPDATE_COMMENT_MUTATION), 2),
    updateComment = _b[0],
    updateError = _b[1].error;
  var _c = __read(useMutation(DELETE_COMMENT_MUTATION), 2),
    deleteComment = _c[0],
    deleteError = _c[1].error;
  var _d = __read(useMutation(LIKE_COMMENT_MUTATION), 2),
    likeComment = _d[0],
    likeError = _d[1].error;
  var _e = __read(useMutation(UNLIKE_COMMENT_MUTATION), 2),
    unlikeComment = _e[0],
    unlikeError = _e[1].error;
  return {
    createComment: createComment,
    updateComment: updateComment,
    deleteComment: deleteComment,
    likeComment: likeComment,
    unlikeComment: unlikeComment,
    createError: createError,
    updateError: updateError,
    deleteError: deleteError,
    likeError: likeError,
    unlikeError: unlikeError
  };
};